export default __webpack_public_path__ + "static/media/480_dummy2016-steuerberatung01-de.123d100e.png";